import React from 'react';
import PhaseSection from './PhaseSection';

export default function WorkflowStageCards({ wsList, gates, users, partners, canAdmin, isDark, theme, mobile, updateItem, deleteItem, onGateAction, siteId, selectedPhases }) {
  const phaseMap = {};
  const phaseOrder = [];
  (wsList || []).forEach(ws => {
    const p = ws.phase || 'Uncategorized';
    if (!phaseMap[p]) {
      phaseMap[p] = [];
      phaseOrder.push(p);
    }
    phaseMap[p].push(ws);
  });

  const gateMap = {};
  (gates || []).forEach(g => { gateMap[g.phase] = g; });
  phaseOrder.sort((a, b) => {
    const ga = gateMap[a], gb = gateMap[b];
    if (ga && gb) return ga.sort_order - gb.sort_order;
    if (ga) return -1;
    if (gb) return 1;
    const fa = phaseMap[a][0], fb = phaseMap[b][0];
    return (fa?.sort_order || 0) - (fb?.sort_order || 0);
  });

  phaseOrder.forEach(p => {
    phaseMap[p].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  });

  function isPreviousPhaseComplete(phaseIndex) {
    if (phaseIndex === 0) return true;
    const prevPhase = phaseOrder[phaseIndex - 1];
    const prevGate = gateMap[prevPhase];
    return prevGate?.status === 'complete';
  }

  // Filter phases: when filter active show only selected, otherwise show all non-locked
  const hasFilter = selectedPhases && selectedPhases.size > 0;
  const visiblePhases = hasFilter
    ? phaseOrder.filter(p => selectedPhases.has(p))
    : phaseOrder.filter(p => { const g = gateMap[p]; return !g || g.status !== 'locked'; });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
      {visiblePhases.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: theme.textSecondary }}>
          <div style={{ fontSize: 32, marginBottom: 12, opacity: 0.4 }}>📋</div>
          <div style={{ fontSize: 15, fontWeight: 500 }}>No active phases yet</div>
          <div style={{ fontSize: 13, marginTop: 4, opacity: 0.7 }}>Unlock a phase gate to get started</div>
        </div>
      )}
      {visiblePhases.map((phase) => {
        const phaseIdx = phaseOrder.indexOf(phase);
        const workstreams = phaseMap[phase];
        const gate = gateMap[phase] || { status: 'active', sort_order: phaseIdx };
        const prevComplete = isPreviousPhaseComplete(phaseIdx);

        return (
          <PhaseSection
            key={phase}
            phase={phase}
            gate={gate}
            workstreams={workstreams}
            users={users}
            canAdmin={canAdmin}
            isDark={isDark}
            theme={theme}
            mobile={mobile}
            updateItem={updateItem}
            deleteItem={deleteItem}
            onGateAction={onGateAction}
            siteId={siteId}
            prevPhaseComplete={prevComplete}
          />
        );
      })}
    </div>
  );
}
